import { computed } from 'vue'
import { useStore } from 'vuex'

export function getScreenUtils() {
  const store = useStore()
  const windowSize = computed(() => store.getters.globals_window_size)
  const mobile = computed(() => windowSize.value.width < 1023)
  return { windowSize, mobile }
}
